import axios from "axios";
import { baseUrl } from "../constants";
//import { setBearerAuthorizationHeader } from "../../utils/interceptors";

const GetVessels = () => {
  return axios
    .get(`${baseUrl()}/Vessel/GetVessels`)
    .then((data) => {
      return data;
    })
      .catch((error) => {
          if (error.response.status === 307) {
              // Handle the specific status code 307 - Status307TemporaryRedirect
              const errResponse = error.response.data;
              let newToken = errResponse.token;

              const _auth = JSON.parse(sessionStorage.getItem("auth"));
              _auth.token = newToken;
              sessionStorage.setItem("auth", JSON.stringify(_auth));

              return axios
                  .get(`${baseUrl()}/Vessel/GetVessels`)
                  .then((data) => {
                      return data;
                  })
                  .catch((error) => {
                      console.error("VesselServices: Get Vessels API", error);
                  });
          } else {
              console.error("VesselServices: Get Vessels API", error);
          }
    });
};

const GetVesselsByProjectId = (projectid) => {
    return axios
        .get(`${baseUrl()}/Vessel/GetVessels/${projectid}`)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .get(`${baseUrl()}/Vessel/GetVessels/${projectid}`)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Get Vessels by ProjectId API", error);
                    });
            } else {
                console.error("VesselServices: Get Vessels by ProjectId API", error);
            }
        });
};

const GetAllVessels = () => {
    return axios
        .get(`${baseUrl()}/Vessel/GetAllVessels`)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .get(`${baseUrl()}/Vessel/GetAllVessels`)
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Get All Vessels API", error);
                    });
            } else {
                console.error("VesselServices: Get All Vessels API", error);
            }
        });
};

const SetVesselStatus = (vesselid, status) => {
    return axios
        .post(`${baseUrl()}/Vessel/SetVesselStatus`, {
            vesselid,
            status
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Vessel/SetVesselStatus`, {
                        vesselid,
                        status
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Set Vessel Status API", error);
                    });
            } else {
                console.error("VesselServices: Set Vessel Status API", error);
            }
        });
};

const DeleteVessel = (vesselid) => {
    return axios
        .post(`${baseUrl()}/Vessel/DeleteVessel`, {
            vesselid
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Vessel/DeleteVessel`, {
                        vesselid
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Delete Vessel API", error);
                    });
            } else {
                console.error("VesselServices: Delete Vessel API", error);
            }
        });
};

const EditVessel = (vesselid, vesselname) => {
    return axios
        .post(`${baseUrl()}/Vessel/EditVessel`, {
            vesselid,
            vesselname
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Vessel/EditVessel`, {
                        vesselid,
                        vesselname
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Edit Vessel API", error);
                    });
            } else {
                console.error("VesselServices: Edit Vessel API", error);
            }
        });
};

const AddVessel = (vesselname, status) => {
    return axios
        .post(`${baseUrl()}/Vessel/AddVessel`, {
            vesselname,
            status
        })
        .then((data) => {
            return data;
        })
        .catch((error) => {
            if (error.response.status === 307) {
                // Handle the specific status code 307 - Status307TemporaryRedirect
                const errResponse = error.response.data;
                let newToken = errResponse.token;

                const _auth = JSON.parse(sessionStorage.getItem("auth"));
                _auth.token = newToken;
                sessionStorage.setItem("auth", JSON.stringify(_auth));

                return axios
                    .post(`${baseUrl()}/Vessel/AddVessel`, {
                        vesselname,
                        status
                    })
                    .then((data) => {
                        return data;
                    })
                    .catch((error) => {
                        console.error("VesselServices: Add Vessel API", error);
                    });
            } else {
                console.error("VesselServices: Add Vessel API", error);
            }
        });
};

const VesselServices = { GetVessels, GetVesselsByProjectId, GetAllVessels, SetVesselStatus, DeleteVessel, EditVessel, AddVessel };

export default VesselServices;
